export interface UserCommunicationCarrier {
  userCommunicationCarrierId?: string;
  userCommunicationId: string;
  carrierId: string;
}
